import React, { useState, useEffect } from "react";
import "./Account.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Profile from "./Profile";
import { FaUserCircle, FaUser } from "react-icons/fa"; // add FaUser here
import { GoLocation } from "react-icons/go";   // Location icon
import { AiOutlineHome } from "react-icons/ai"; // Home icon
import { FiLogOut } from "react-icons/fi";
import MyProfile from "./MyProfile";
import PostponeModal from "./PostponeModal";
import ReviewModal from "./ReviewModal";

const Account = () => {
  const navigate = useNavigate();
  const [sidebarPage, setSidebarPage] = useState("profile");
  const [journeyTab, setJourneyTab] = useState("active");
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
const [showPostponeModal, setShowPostponeModal] = useState(false);
const [selectedBooking, setSelectedBooking] = useState(null);
const [showReviewModal, setShowReviewModal] = useState(false);
const [selectedReviewBooking, setSelectedReviewBooking] = useState(null);

  // Get user info from localStorage (saved by AuthContext)
  const storedUser = JSON.parse(localStorage.getItem("hm_user")) || {};
  const email = storedUser.email;
  const userName = storedUser.fullName || "User";

  // Fetch bookings using email
useEffect(() => {
  const fetchPostponeRequests = async () => {
    try {
      const res = await axios.get(`/api/postpone/user/${storedUser._id}`);
      if (res.data.success) {
        // Map bookingId to its postpone status
        const map = {};
        res.data.data.forEach((req) => {
          if (req.bookingId) map[req.bookingId._id] = req.status;
        });
        return map;
      }
    } catch (err) {
      console.log("Error fetching postpone requests", err);
    }
    return {};
  };

  const fetchData = async () => {
    if (!email) return;

    setLoading(true);

    try {
      const bookingsRes = await axios.post("/api/booking/get-booking-by-email", { email });
      let bookingsData = [];
      if (bookingsRes.data.success) bookingsData = bookingsRes.data.data;

      const postponeMap = await fetchPostponeRequests();

      // Add postponeStatus to each booking
      bookingsData = bookingsData.map((b) => ({
        ...b,
        postponeStatus: postponeMap[b._id] || null,
      }));

      setBookings(bookingsData);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  fetchData();
}, [email]);


  // Categorize bookings into active, upcoming, past
// Categorize bookings into active, upcoming, past (MULTI-DAY FIXED)
const categorize = () => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const upcoming = [];
  const active = [];
  const past = [];

  bookings.forEach((b) => {
    const [startStr, endStr] = b.tripDate?.split(" - ") || [];

    const startDate = startStr ? new Date(startStr) : null;
    const endDate = endStr ? new Date(endStr) : null;

    if (!startDate || !endDate) {
      past.push(b);
      return;
    }

    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(0, 0, 0, 0);

    if (today < startDate) {
      upcoming.push(b);
    } else if (today > endDate) {
      past.push(b);
    } else {
      active.push(b); // today is between start and end
    }
  });

  return { upcoming, active, past };
};


  const { active, upcoming, past } = categorize();

 const renderBookings = (list) => {
  if (loading) return <p>Loading...</p>;
  if (!list || list.length === 0) return <p>No bookings found in this category.</p>;

  return (
    <div className="account-booking-list">
      {list.map((b, i) => (
        <div className="account-booking-card" key={i}>

          <h3 className="journey-trip-name">{b.tripName}</h3>

          <div className="row-between">
            <p><strong>Departure:</strong> {b.departure || "—"}</p>
            <p><strong>Arrival:</strong> {b.arrival || "—"}</p>
          </div>

          <p>
            <strong>Travellers:</strong>{" "}
{b.occupancy?.map(o => `${o.count} Travellers`).join(", ") || "—"}
          </p>

          <p><strong>Trip Price:</strong> ₹{b.totalAmount}</p>
{
  (() => {
    const [start, end] = b.tripDate?.split(" - ") || [];
    return (
      <p>
        <strong>Trip Dates:</strong>{" "}
        {start ? new Date(start).toLocaleDateString() : "—"} –{" "}
        {end ? new Date(end).toLocaleDateString() : "—"}
      </p>
    );
  })()
}

          <div className="journey-buttons">

  {/* ACTIVE BOOKINGS */}
  {journeyTab === "active" && (
    <>
<button
      className="btn-red"
      onClick={() => {
        // Redirect to WhatsApp chat
        window.open("https://wa.me/919888823721", "_blank");
      }}
    >
      Support
    </button>
      {/* Show Payment Due only if remainingAmount > 0 */}
      {parseInt(b.remainingAmount || 0) > 0 && (
        <button className="btn-yellow">
          Payment Due: ₹{b.remainingAmount}
        </button>
      )}
    </>
  )}

  {/* UPCOMING BOOKINGS */}
 {/* UPCOMING BOOKINGS */}
{journeyTab === "upcoming" && (
  <>
    {b.postponeStatus === "pending" ? (
      <button className="btn-gray" disabled>
        Postpone Requested
      </button>
    ) : (
      <button
        className="btn-blue"
        onClick={() => {
          setSelectedBooking(b);
          setShowPostponeModal(true);
        }}
      >
        Postpone
      </button>
    )}

    {parseInt(b.remainingAmount || 0) > 0 && (
      <button className="btn-yellow">
        Payment Due: ₹{b.remainingAmount}
      </button>
    )}
  </>
)}


  {/* PAST BOOKINGS */}
  {journeyTab === "past" && (
    <>
<button
  className="btn-green"
  onClick={() => {
    setSelectedReviewBooking(b);
    setShowReviewModal(true);
  }}
>
  Review
</button>
 <button
      className="btn-yellow"
      onClick={() => {
        const startEnd = b.tripDate || "Dates not available";

        // Replace spaces with dashes to match actual trip URL
        const slug = b.tripName.replace(/\s+/g, "-");
        const tripLink = `https://www.highmountains.in/trip/${slug}`;

        const message = `Hey! Check out my trip "${b.tripName}" from ${b.departure} to ${b.arrival}, happening on ${startEnd}. Total price: ₹${b.totalAmount}. See more: ${tripLink}`;

        const encodedMessage = encodeURIComponent(message);

        window.open(`https://wa.me/?text=${encodedMessage}`, "_blank");
      }}
    >
      Share
    </button>
    </>
  )}

</div>


        </div>
      ))}
    </div>
  );
};

  const logout = () => {
    localStorage.removeItem("hm_token");
    localStorage.removeItem("hm_user");
    navigate("/");
    window.location.reload();
  };

  return (
    <div className="account-container">
   <div className="account-sidebar">

  {/* TOP SECTION */}
  <div className="account-sidebar-top">
    <h3>Hi, {userName}</h3>

    <ul>
      <li
        className={sidebarPage === "journey" ? "active" : ""}
        onClick={() => setSidebarPage("journey")}
      >
        My Journey
      </li>
      <li
  className={sidebarPage === "myprofile" ? "active" : ""}
  onClick={() => setSidebarPage("myprofile")}
>
  My Profile
</li>

    </ul>
  </div>

  {/* BOTTOM SECTION */}
  <div className="account-sidebar-bottom">

    <div
      className="account-sidebar-profile-icon"
      onClick={() => setSidebarPage("profile")}
    >
      {userName.charAt(0).toUpperCase()}
    </div>

    <button className="logout-btn" onClick={logout}>
      Logout
    </button>

  </div>
  
</div>

{/* MOBILE BOTTOM STICKY MENU */}

{/* MOBILE BOTTOM STICKY MENU */}
<div className="account-bottom-menu">

  {/* Home */}
  <div 
    className="menu-item"
    onClick={() => navigate("/")}
  >
    <AiOutlineHome size={24} />
  </div>

  {/* Journey */}
  <div 
    className={`menu-item ${sidebarPage === "journey" ? "active" : ""}`}
    onClick={() => {
      setSidebarPage("journey");
      window.scrollTo({ top: 0, behavior: "smooth" });
    }}
  >
    <GoLocation size={24} />
  </div>

  {/* Profile */}
  <div 
    className={`menu-item ${sidebarPage === "profile" ? "active" : ""}`}
    onClick={() => {
      setSidebarPage("profile");
      window.scrollTo({ top: 0, behavior: "smooth" });
    }}
  >
  <FaUser size={24} />  {/* changed icon */}
  </div>

  {/* Logout */}
  <div 
    className="menu-item"
    onClick={logout}
  >
    <FiLogOut size={24} />
  </div>
{/* Public Profile (View Profile Page) */}
<div 
  className={`menu-item ${sidebarPage === "myprofile" ? "active" : ""}`}
  onClick={() => {
    setSidebarPage("myprofile");
    window.scrollTo({ top: 0, behavior: "smooth" });
  }}
>
  <FaUserCircle size={24} />
</div>

</div>


      <div className="account-content">
        {sidebarPage === "profile" && <Profile />}
{sidebarPage === "myprofile" && (
  <MyProfile 
    user={storedUser} 
    setSidebarPage={setSidebarPage} 
  />
)}

        {sidebarPage === "journey" && (
          <div className="journey-wrapper">
            <h2>My Journeys</h2>
            <div className="account-tabs">
              <button
                onClick={() => setJourneyTab("active")}
                className={journeyTab === "active" ? "active" : ""}
              >
                Active
              </button>
              <button
                onClick={() => setJourneyTab("upcoming")}
                className={journeyTab === "upcoming" ? "active" : ""}
              >
                Upcoming
              </button>
              <button
                onClick={() => setJourneyTab("past")}
                className={journeyTab === "past" ? "active" : ""}
              >
                Past
              </button>
            </div>

            <div className="journey-content">
              {journeyTab === "active" && renderBookings(active)}
              {journeyTab === "upcoming" && renderBookings(upcoming)}
              {journeyTab === "past" && renderBookings(past)}
            </div>
          </div>
        )}
      </div>
     {showPostponeModal && (
  <PostponeModal
  booking={selectedBooking}
  closeModal={() => setShowPostponeModal(false)}
  onRequestSubmitted={(updatedBooking) => {
    // Update bookings array with new date AND status
    setBookings((prev) =>
      prev.map((b) =>
        b._id === updatedBooking._id
          ? { ...b, tripDate: updatedBooking.newDate, postponeStatus: "pending" }
          : b
      )
    );
  }}
/>

)}
{showReviewModal && (
  <ReviewModal
    booking={selectedReviewBooking}
    user={storedUser}
    closeModal={() => setShowReviewModal(false)}
    onReviewSubmitted={() => {
      setShowReviewModal(false);
alert("Thank you! Your review has been submitted and is now live!");
    }}
  />
)}


    </div>
    
  );
};

export default Account;
